export default {
    url: '/detail/:id',
    template: `
        <div class="heading01 type01">
            <a class="btn discrete" ui-sref="authorized.manage.permissions.roles.list()">{{ 'general.Back to list' | translate }}</a>
            <h1>{{ vm.role.name }}</h1>
        </div>
        <ul class="tabs01">
            <li>
                <a ui-sref-active="active"
                ui-sref="authorized.manage.permissions.roles.detail.privileges()">{{ 'role.Privileges' | translate }}</a>
            </li>
            <li>
                <a ui-sref-active="active"
                ui-sref="authorized.manage.permissions.roles.detail.users()" >{{ 'role.Affected users' | translate }}</a>
            </li>
        </ul>
        <ui-view></ui-view>
    `,
    abstract: true,
    resolve: {
        role (RoleResource, $stateParams) {
            return RoleResource.get({ id: $stateParams.id }).$promise;
        }
    },
    controller (role) {
        this.role = role;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/roles/detail/index.js